import styled from "styled-components";

export const CircularContainer = styled("div")`
  width: calc(100vw - 240px);
  display: flex;
  justify-content: center;
  align-items: center;
`